import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {Scene} from "./story";
import {headers} from "./headers";
import {Tag} from "./fields";
import {host} from "./api";

export interface SceneState {
    scenes: Array<Scene>,
    status: Status,
    scene: Scene | undefined,
    error: string | null | undefined
}

const initialState: SceneState = {
    scenes: [],
    status: Status.Idle,
    scene: undefined,
    error: null,
}

export const fetchScenes = createAsyncThunk('scenes', async (params: {projectId: number, chapterId: number}) => {
    const response = await axios.get(`${host}/chapters/${params.chapterId}/scenes`, {
        headers: headers(params.projectId?.toString())
    })
    return response.data
})

export const fetchScene = createAsyncThunk('fetchScene', async (params: {projectId: number, sceneId: number}) => {
    const response = await axios.get(`${host}/scenes/${params.sceneId}`, {
        headers: headers(params.projectId?.toString())
    })
    return response.data
})

export const saveScene = createAsyncThunk('saveScene', async (params: { projectId: number, scene: Scene }) => {
    const response = await axios.post(`${host}/scenes`,
        params.scene,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const deleteScene = createAsyncThunk('deleteScene', async (params: { projectId: number, sceneId: number }) => {
    const response = await axios.delete(`${host}/scenes/${params.sceneId}`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const removeSceneTag = createAsyncThunk('removeSceneTag', async (params: { projectId: number, sceneId: number, tagId: number }) => {
    const response = await axios.delete(`${host}/scenes/${params.sceneId}/tags/${params.tagId}`,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const addSceneTag = createAsyncThunk('addSceneTag', async (params: { projectId: number, sceneId: number, tag: Tag }) => {
    const response = await axios.post(`${host}/scenes/${params.sceneId}/tags`,
        params.tag,
        {
            headers: headers(params.projectId.toString())
        })
    return response.data
})

export const scenesSlice = createSlice({
    name: 'scenes',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder
            .addCase(fetchScenes.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchScenes.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.scenes = action.payload
            })
            .addCase(fetchScenes.rejected, (state, action) => {
                state.status = Status.Failed
                state.error = action.error.message
            })
            .addCase(removeSceneTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(removeSceneTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addSceneTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addSceneTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(saveScene.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveScene.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(fetchScene.pending, (state, action) => {
                state.status = Status.Loading
                state.scene = undefined
            })
            .addCase(fetchScene.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.scene = action.payload
            })
            .addCase(deleteScene.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteScene.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
    }
})

export default scenesSlice.reducer;